import * as actionTypes from './actionTypes';
import axios from '../../utilities/interceptor';
import { getMessage } from '../../utilities/getMessage';

export const createMaster=(request)=>async dispatch=>{
    dispatch({
        type:actionTypes.CREATE_MASTER_START
    })
    const options={
        url:`/auth/master/signup`,
        method:'POST',
        data:request
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CREATE_MASTER_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CREATE_MASTER_FAIL,
                payload:getMessage(error)
            }))
}